import React from 'react';
import { Container, Row, Col, } from 'react-bootstrap';

import MusicIndex from './MusicIndex'

export default function PressBio() {

    return (
        <Container>
            <Row>
                <MusicIndex />
                <Col>
                    <h2>Music Biography</h2>
                    <div align="center">
                        <h3>Bruce Holmes</h3>
                        <br></br>
                        <p><em>Bruce Holmes looks at our human foibles with a clear eye,<br></br>
                            no illusions and a loving sense of humor.</em> </p>
                    </div>
                    <div align="right">
                        <p>Banjo-Jim Foerch, Grand River Folk Arts Society</p>
                        <br></br>
                    </div>
                    <p>Bruce Holmes believes in community, sing-alongs, funny stories, the thrill of lust and the depth of love.  He’s willing to challenge the unexamined assumptions we make.  He wants people to cherish their lives, both the joy and the pain.<br></br>
                    </p>
                    <p>Bruce’s influences are many.  He loves Celtic music and plays the concertina and bouzouki.  He sings Sacred Harp, and you’ll hear some unusual harmonies in his music.  He’s studied flat-picking with the bluegrass folks.  And he grew up on rock and roll so you’ll hear a touch of the Byrds or Jethro Tull in his music.  But he’s also got stories to tell, so he wants the vocals high in the mix.  At heart he’s a folk singer who loves a good story.  And a lifetime of stories is shared in his songs.<br></br>
                    </p>
                    <p>Holmes has spent most of his life teaching.  He’s taught everything from Aikido to folk dancing to juggling to chess (he was the coach for Oakton Chess, Illinois State Champions in 1993 and 1994).  He’s the author of Anvil of the Heart, a science fiction novel that made the Locus recommended reading list for 1984.  He also created a 48 lessons series on the Feldenkrais Method that is used all around the globe. He's also a triathlon coach certified by USA Triathlon, the Olympic Committee's organization supporting triathlon in the US.<br></br>
                    </p>
                    <p>His first CD, Life’s An Intelligence Test, resonates with a lifetime of musical influences.  It has been adopted for airplay by over 200 radio stations.  (Radio Teutoburger Wald in Germany called it “a masterpiece of acoustic music.”)  Half the songs from the CD have been honored in some way including a 2nd Place and 3rd Place in the 2006 Great Lakes Songwriting Competition. In 2007 he was selected as one of five Finalists in the Texas Songwriters’ Serenade.  In 2008 he won the annual Talent Show at the Coffee House in Milwaukee. In 2009 he again won 3rd Place in the Great Lakes Songwriting Competition. You can hear the music at www.BruceHolmes.com<br></br>
                    </p>
                    <p>Booking:<br></br>
                    </p>
                    <p align="center">Haven Music<br></br>
                    </p>
                    <p align="center">Bruce@BruceTHolmes.com | www.BruceHolmes.com | 847-869-1409<br></br>
                    </p>
                    <p align="center">1115 Mulford Street, Evanston, IL 60202-3318<br></br>
                    </p>
                </Col>
            </Row>
        </Container>
    )
}